import React from 'react'
import {connect} from 'react-redux'
import {Chart} from 'react-google-charts';
import {formatarReal} from '../../util/numberUtil';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import {listaCores} from '../../util/constantsUtil';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import moment from 'moment';


export class GraficoTopBilheteiros extends React.Component {


    tooltip(item) {
        return '<div class="google-visualization-tooltip-item"><strong style="font-size: 16px";">' + capitalizarTodasPrimeirasLetras(item.nome) + '</strong><br/>' +
            '<span style="font-size: 16px"> (Q.Aprov=):  <strong>' + item.quantidadeVendas + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Canc =):  <strong>' + item.quantidadeCancelamentos + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (T.Aprovado=):  <strong>' + formatarReal(item.valorTotalVendas.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (T.Cancelado=):  <strong>' + formatarReal(item.valorTotalCancelamentos.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (F.Liquid=):  <strong>' + formatarReal(item.valorTotalVendasLiquido.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (I.liquid=):  <strong>' + formatarReal(item.valorTotalImposto.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (L. Comissão=):  <strong>' + formatarReal(item.valorTotalComissao.toString()) + '</strong></span></div>'

    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'VexBi - Faturamento por Bilheteiro.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarGraficoPorBilheteiro() {
        let arquivo = 'Bilheteiro;Representação de porcentagem;Q. Aprov;Q. Cancelada;T. Faturado;V. Cancelado;F. Liquido; Imposto Líquido; L. Comissão\n';

        const idEmpresa = this.props.empresaSelecionada.id;
        let size = this.props.vexadoBI.totalRegistrosVendedor
        
        const { grupos, empresas, empresasSemGrupo } = this.props.getGruposOuEmpresas();
        
        let url = `${URL}/vexado-bi/vendedores?idEmpresa=${idEmpresa}&dataInicio=${moment(this.props.dataInicio)
            .format('YYYY-MM-DD')}&dataFim=${moment(this.props.dataFim)
            .format('YYYY-MM-DD')}&size=${size}&empresasSemGrupo=${empresasSemGrupo}`;

        if (grupos) {
            url = `${url}&grupos=${grupos}`            
        }
                
        if (empresas) {
            url = `${url}&empresas=${empresas}`
        }
        
        let retorno = await axios.get(url, SLOW_REQUEST_CONFIG);
        
        retorno = [...retorno.data.totalFaturamentoPorVendedor].sort((a, b) => b.quantidadeVendas - a.quantidadeVendas);

        arquivo = `${arquivo}${retorno.map(it => {
            const bilheteiro = capitalizarTodasPrimeirasLetras(it.nome);
            const valorTotalVendas = it.valorTotalVendas.toString().replace('.', ',')
            const valorTotalCancelamentos = it.valorTotalCancelamentos.toString().replace('.', ',')
            const valorTotalVendasLiquido = it.valorTotalVendasLiquido.toString().replace('.', ',')
            const valorTotalImposto = it.valorTotalImposto.toString().replace('.', ',')
            const valorTotalComissao = it.valorTotalComissao.toString().replace('.', ',')

            let valor = `${bilheteiro};${it.porcentagemVendas};${it.quantidadeVendas};"${it.quantidadeCancelamentos}";"${valorTotalVendas}";"${valorTotalCancelamentos}";"${valorTotalVendasLiquido}";"${valorTotalImposto}";"${valorTotalComissao}"`
            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo)
    }

    render() {
        const retorno = [];
        retorno.push(['Bilheteiro', 'Valor', {role: 'style'}, {
            role: 'tooltip',
            type: 'string',
            p: {html: true}
        }]);
        this.props.vexadoBI.totalFaturamentoPorVendedor.forEach((it, index) => retorno.push([capitalizarTodasPrimeirasLetras(it.nome), it.valorTotalVendas, listaCores[index], this.tooltip(it)]));

        return <React.Fragment>
            <Chart chartType="ColumnChart"
                   data={retorno}
                   options={{
                       title: 'Top Bilheteiros',
                       hAxis: {
                           title: 'Bilheteiro',
                           minValue: 0,
                       },
                       vAxis: {
                           title: 'Valor',
                       },
                       legend: {position: 'none'},
                       tooltip: {isHtml: true}

                   }}
                   width={'100%'}
                   height={this.props.full ? '800px' : '400px'}
            />
            {this.props.full ? null : <button className="input-group-text bg-white btn-campo-busca float-right"
                                            onClick={() => this.props.expandir('vendedor')}>Expandir</button>}
            {this.props.full ? null : <button className="input-group-text btn-laranja btn-campo-busca float-right exportar"
                                            onClick={() => this.exportarGraficoPorBilheteiro()}>Exportar Lista</button>}             
        </React.Fragment>
    }
}

export function mapStateToProps(state) {
    return {
        vexadoBI: state.vexadoBI,
        empresaSelecionada: state.empresaSelecionada
    }
}

export default connect(mapStateToProps, {})(GraficoTopBilheteiros)
